module.exports = __webpack_public_path__ + "img/arms_3_2.915e91b9.png";